import { LinkButton } from "@components/buttons"
import { FlexBox } from "@components/wrapper"
import { HARISENIN_PUBLIC_PAGE_ASSETS } from "@constants/pictures"
import clsx from "clsx"
import Image from "next/image"
import React from "react"

export const ProgramNewCta = ({ withMargin = true, isBootcamp }: { withMargin?: boolean, isBootcamp?: boolean }) => {
  return (
    <section
      className={clsx(
        "relative w-full",
        withMargin && "sm:mb-15 mb-8",
        isBootcamp && "sm:rounded-lg rounded-10"
      )}
    >
      <Image
        src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/product-detail_cta.jpeg`}
        alt="cta-top-left"
        width={1880}
        height={1255}
        className={clsx(
          "w-full object-cover",
          "sm:h-[105px] h-[150px]",
          isBootcamp && "rounded-10"
        )}
      />
      <FlexBox
        className={clsx(
          "absolute top-0 wh-full",
          "py-6 sm:px-9 px-6",
          "sm:justify-between sm-only:flex-col justify-center",
          isBootcamp ? "sm:items-center items-start" : "items-center"
        )}
        style={{ background: "linear-gradient(90deg, #212121 0%, rgba(33, 33, 33, 0.00) 100%)" }}
      >
        <div className="text-white sm-only:text-center">
          <div className={clsx("mb-2 text-sm", isBootcamp && "text-left")}>
            Ada yang mau ditanyakan lebih lanjut?
          </div>
          <div className="font-urbanist font-semibold text-xl sm-only:mb-3">Boleh banget chat tim kami!</div>
        </div>
        <LinkButton
          // href="https://api.whatsapp.com/send?phone=6281312117711"
          href="https://harisenin.link/Je9pt"
          className={clsx("sm:w-fit w-full ", isBootcamp ? "rounded-lg sm-only:h-[44px]" : "!rounded-none")}
          variant="solid-blue"
          customFontSize="text-sm"
        >
          Tanya Sekarang
        </LinkButton>
      </FlexBox>
    </section>
  )
}
